import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { observer } from "mobx-react-lite";
import { enumMap, RBDItemType, RBDType } from "../../app/config/enum";
import { useStore } from "../../app/stores/store";

function RBDSettingItemType() {
    const { rbdStore } = useStore();

    const handleChange = (e: SelectChangeEvent<RBDItemType>) => {
        rbdStore.setSelectedItemType(e.target.value as RBDItemType);
    }
    
    return (
        <FormControl fullWidth sx={{mb:4}}>
            <InputLabel focused={rbdStore.selectedRbdType === RBDType.STATION ? false : undefined} id="itemTypeLabel">Item Type</InputLabel>
            <Select
                labelId="itemTypeLabel"
                value={rbdStore.selectedItemType}
                label="Item Type"
                onChange={(e) => handleChange(e)}
                disabled={rbdStore.isEdit || rbdStore.selectedRbdType === RBDType.STATION}
            >
                {enumMap(RBDItemType, (value, desc, idx) => (
                    <MenuItem key={idx} value={value}>{desc}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default observer(RBDSettingItemType);